// ============ plugin import =========== //
import {useState, useEffect, useRef} from 'react'
import axios from 'axios'
// ============ component import ============= //
import AddServiceAttributeAssociation from './component/AddServiceAttributeAssociation';
import ServiceAttributeAssociationList from './component/ServiceAttributeAssociationList';
import ServiceAttributeAssociationUpdateDrawer from './component/ServiceAttributeAssociationUpdateDrawer';
import SideDrawer from '../../../../../../../../component/common/SideDrawer';

const ServiceAttributeAssociation = (props) => {
    const {
        formData, 
        formValidateError,
        pfAssSetupApiIsCall
    } = props;
    const api_base_url = process.env.REACT_APP_API_URL;
    const loginUserType = localStorage.getItem('type');

    // ---------- define all state here ---------- //
    const [ assServiceWithAttributeChange, setAssServiceWithAttributeChange] = useState(false);
    const [ serviceAttributeAssUpdateId, setServiceAttributeAssUpdateId ] = useState(-1);
    const [ serviceAttributeAssData, setServiceAttributeAssData] = useState([]);
    const [ saaDrawerIsOpen, setSaaDrawerIsOpen] = useState(false)
    const [serviceAttributeAssUpdateData, setServiceAttributeAssUpdateData] = useState([]);

    const saveServiceAttributeAssociateHandler = async (associateData) => {

        if(Object.keys(associateData).length === 0) return;
        setAssServiceWithAttributeChange(true)
        if (!Array.isArray(associateData.service_attribute_association)) {
            associateData.service_attribute_association = [associateData.service_attribute_association];
        }

        if(serviceAttributeAssUpdateId < 0){
            // ---- insert
            props.onInputChange(
                'step4',
                'service_attributes_association_setup',
                [
                    ...(Array.isArray(formData['step4'].service_attributes_association_setup) ? formData['step4'].service_attributes_association_setup : []),
                    associateData
                ]
            );
            setServiceAttributeAssData((prevList) => [...prevList, associateData]);
        }
        else{
            // --- update
            const updateServiceAttributeAssData = [...formData['step4'].service_attributes_association_setup];
            
            updateServiceAttributeAssData[serviceAttributeAssUpdateId] = associateData;
            setServiceAttributeAssData(updateServiceAttributeAssData);
            props.onInputChange(
                'step4',
                'service_attributes_association_setup',
                updateServiceAttributeAssData
            );
            setSaaDrawerIsOpen(false)
        }
        setServiceAttributeAssUpdateId(-1)
    }

    const serviceAttributeAssociationDeleteHandler = (index) => {
        setAssServiceWithAttributeChange(true)
        const serviceAttributeAssUpdate = [...serviceAttributeAssData];
        serviceAttributeAssUpdate.splice(index, 1);
        setServiceAttributeAssData(serviceAttributeAssUpdate);
        props.onInputChange(
            'step4',
            'service_attributes_association_setup',
            serviceAttributeAssUpdate
        );
    }
    const serviceAttributeAssUpdateOnClickHandler = (index) => {
        setServiceAttributeAssUpdateData([serviceAttributeAssData[index]])
        setServiceAttributeAssUpdateId(index)
        setSaaDrawerIsOpen(true)
    }
    const drawerOnCloseHandler = (drawerName) => {
        const drawerMap = {
            saa_update_drawer: () => {
                setSaaDrawerIsOpen(false)
                setServiceAttributeAssUpdateId(-1)
            }
        };
        if (drawerMap[drawerName]) {
            drawerMap[drawerName]();
        }
    }

    useEffect(() => {
        setServiceAttributeAssData(formData['step4'].service_attributes_association_setup);
    },[formData['step4']]);

    const serviceAttributeAssFrmRef = useRef();
    useEffect(() => {
        const saveServiceAttributeAssData = async () => {
            if(
                !assServiceWithAttributeChange &&
                !pfAssSetupApiIsCall
            ) return;
            const saveAssData = async () => {
                let othersData = [];
                if(serviceAttributeAssData.length > 0){
                    const serviceAttributeIndexData = serviceAttributeAssData.map((others, index) => ({
                        ...others,
                        index,
                    }));
                    othersData = serviceAttributeIndexData
                }
                let apiToken = '';
                if(loginUserType === 'A'){
                    apiToken = localStorage.getItem('token');
                }
                else if(loginUserType === 'D'){
                    apiToken = localStorage.getItem('developertoken');
                }
                else if(loginUserType === 'SA') {
                    apiToken = localStorage.getItem('systemAdminToken')
                }
                let othersFormData = new FormData();
                othersFormData.append("action_type", 'service_attributes_association_setup');
                othersFormData.append("bot_id", formData.bot_id);
                othersFormData.append("step", "step4");
                othersFormData.append("data", JSON.stringify(othersData));
                othersFormData.append("sass_id", localStorage.getItem('sass_id'));
                othersFormData.append("user_type", localStorage.getItem('type'));
                othersFormData.append("user_name", loginUserType == 'SA' ? localStorage.getItem('system_username') : '');
                const apiHeaders = {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "x-access-token": apiToken,
                    },
                };
                try {
                    await axios.post(`${api_base_url}api/save-bot-details`, othersFormData, apiHeaders)
                    .then(async (res) => {
                        if(res.data.status === 'success'){
                            othersFormData = new FormData();
                            setAssServiceWithAttributeChange(false)
                            props.associationSetupIsRefresh(false)
                            serviceAttributeAssFrmRef.current?.resetForm();
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                } catch (error) {
                    console.error("Error during save:", error);
                }
            }
            await saveAssData();
        }
        saveServiceAttributeAssData();
    },[serviceAttributeAssData, pfAssSetupApiIsCall])

    return (
        <>
            <div className="row mb-5 border border-dashed border-gray-400 rounded p-5">
                <a className="fw-bold text-gray-800 mb-2 fs-3">
                    Service Attribute Association
                </a>
                <div className='col-md-12'>
                    <AddServiceAttributeAssociation
                        formData={formData}
                        formValidateError = {formValidateError}
                        saveServiceAttributeAssociate={saveServiceAttributeAssociateHandler}
                        serviceAttributeAssUpdateData={serviceAttributeAssUpdateData}
                        isInfoOpenHandler={props.isInfoOpenHandler}
                        ref={serviceAttributeAssFrmRef}
                    />
                </div>
                <div className='col-md-12'>
                    <ServiceAttributeAssociationList
                        serviceAttributeAssData={serviceAttributeAssData}
                        serviceAttributeAssociationDelete={serviceAttributeAssociationDeleteHandler}
                        serviceAttributeAssUpdateOnClick={serviceAttributeAssUpdateOnClickHandler}
                    />
                </div>
            </div>
            <SideDrawer
                title={'Data Update'}
                width={600}
                open={saaDrawerIsOpen}
                drawer_name={'saa_update_drawer'}
                placement={'right'}
                closable={false}
                drawerOnClose={drawerOnCloseHandler}
            >
                <ServiceAttributeAssociationUpdateDrawer
                   formData={formData}
                   saveServiceAttributeAssociate={saveServiceAttributeAssociateHandler}
                   serviceAttributeAssUpdateData={serviceAttributeAssUpdateData}
                   ref={serviceAttributeAssFrmRef}
                />
            </SideDrawer>
        </>
    )
}

export default ServiceAttributeAssociation
